import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { login } from '../containers/User/AuthSlice';

export default function LoginForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/'; // Get the original page or default to home

    const [error, setError] = useState(null);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form from refreshing the page
        try {
            const loginSuccess = await dispatch(login(email, password));

            if (loginSuccess) {
                navigate(from, { replace: true }); // Redirect to the original page
            } else {
                setError('Login failed. Please check your credentials and try again.');
            }
        } catch (err) {
            setError('Login failed. Please try again.');
        }
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', marginTop: '20px' }}>
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label htmlFor='email' style={{ display: 'block', marginBottom: '5px' }}>
                        Email:
                    </label>
                    <input
                        type='email'
                        id='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label htmlFor='password' style={{ display: 'block', marginBottom: '5px' }}>
                        Password:
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id='password'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                        />
                        {/* <button
                            type='button'
                            onClick={toggleShowPassword}
                            style={{
                                marginLeft: '10px',
                                padding: '8px',
                                backgroundColor: '#007BFF',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                            }}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </button> */}
                    </div>
                </div>
                <button
                    type='submit'
                    style={{ width: '100%', padding: '10px', backgroundColor: '#007BFF', color: '#fff', border: 'none', borderRadius: '4px' }}
                >
                    Login
                </button>
            </form>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {/* <p>-{user ? user.email : ''}-</p> */}
        </div>
    );
}
